import axios from '@/utils/request'

// 分账管理-账户列表
export function getMerchants(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/merchants`,
    method: 'get',
    params
  })
}
// 分账管理-账户详情
export function getMerchantsDetail(thirdAccountId) {
  return axios({
    url: `/manager/trade/allocfund/merchants/${thirdAccountId}`,
    method: 'get'
  })
}
// 分账管理-分账交易-订单查询
export function getAllocfundOrders(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/orders`,
    method: 'get',
    params
  })
}
// 分账管理-分账交易-订单搜索
export function getAllocfundSearch(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/orders/search`,
    method: 'get',
    params
  })
}
// 分账管理-分账交易-订单详情
export function getAllocfundDetail(allocOrderId) {
  return axios({
    url: `/manager/trade/allocfund/orders/${allocOrderId}`,
    method: 'get'
  })
}
// 分账管理-分账退款-退款查询
export function getRefunds(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/refunds`,
    method: 'get',
    params
  })
}
// 分账管理-分账退款-退款搜索
export function getRefundsSearch(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/refunds/search`,
    method: 'get',
    params
  })
}
// 分账管理-分账退款-退款详情
export function getRefundsDetail(allocRefundId) {
  return axios({
    url: `/manager/trade/allocfund/refunds/${allocRefundId}`,
    method: 'get'
  })
}
// 分账管理-手工结算-结算订单查询
export function getSettleorders(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/settleorders`,
    method: 'get',
    params
  })
}
// 分账管理-手工结算-结算订单搜索
export function getSettleordersSearch(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/settleorders/search`,
    method: 'get',
    params
  })
}
// 分账管理-手工结算-订单详情
export function getSettleordersDetail(settleOrderId) {
  return axios({
    url: `/manager/trade/allocfund/settleorders/${settleOrderId}`,
    method: 'get'
  })
}
// 分账管理-手工结算-订单同步
export function setSettleordersSync(settleOrderId, type) {
  return axios({
    url: `/manager/trade/allocfund/settleorders/${settleOrderId}/sync`,
    method: 'get',
    Headers: {
      'type': type
    }
  })
}
// 分账管理-手工结算-订单通知
export function setSettleordersNotify(settleOrderId, type) {
  return axios({
    url: `/manager/trade/allocfund/settleorders/${settleOrderId}/notify`,
    method: 'post',
    Headers: {
      'type': type
    }
  })
}
// 分账管理-自动结算-结算列表
export function getAutosettles(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/autosettles`,
    method: 'get',
    params
  })
}
// 分账管理-担保交易-担保查询
export function getGuaranteeorders(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/guaranteeorders`,
    method: 'get',
    params
  })
}
// 分账管理-担保交易-担保搜索
export function getGuaranteeordersSearch(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/guaranteeorders/search`,
    method: 'get',
    params
  })
}
// 分账管理-担保交易-担保详情
export function getGuaranteeordersDetail(guaranteeOrderId) {
  return axios({
    url: `/manager/trade/allocfund/guaranteeorders/${guaranteeOrderId}`,
    method: 'get'
  })
}
//分账交易-订单导出
export function exportAllocfundOrders(params) {
  return axios({
    responseType: 'blob',
    url: `/manager/trade/allocfund/orders/export`,
    method: 'post',
    params
  })
}
// 分账退款-退款导出
export function exportRefunds(params) {
  return axios({
    responseType: 'blob',
    url: `/manager/trade/allocfund/refunds/export`,
    method: 'post',
    params
  })
}
// 手工结算-结算订单导出
export function exportSettleorders(params) {
  return axios({
    responseType: 'blob',
    url: `/manager/trade/allocfund/settleorders/export`,
    method: 'post',
    params
  })
}
// 自动结算-结算订单导出
export function exportAutosettlesorders(params) {
  return axios({
    responseType: 'blob',
    url: `/manager/trade/allocfund/autosettles/export`,
    method: 'post',
    params
  })
}
// 担保交易-订单导出
export function exportGuaranteeorders(params) {
  return axios({
    responseType: 'blob',
    url: `/manager/trade/allocfund/guaranteeorders/export`,
    method: 'post',
    params
  })
}

// 账户转账查询
export function getTransferorder(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/transferorder`,
    method: 'get',
    params
  })
}
// 账户转账搜索
export function getTransferorderSearch(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/transferorder/search`,
    method: 'get',
    params
  })
}
// 账户转账详情
export function getTransferordersDetail(orderId) {
  return axios({
    url: `/manager/trade/allocfund/transferorder/${orderId}`,
    method: 'get'
  })
}
// 账户转账导出
export function exportTransferorder(params) {
  return axios({
    responseType: 'blob',
    url: `/manager/trade/allocfund/transferorder/export`,
    method: 'post',
    params
  })
}
// 账户转账同步
export function setTransferSync(orderId, type) {
  return axios({
    url: `/manager/trade/allocfund/transferorder/${orderId}/sync`,
    method: 'get',
    Headers: {
      'type': type
    }
  })
}
// 账户转账通知
export function setTransferNotify(orderId, type) {
  return axios({
    url: `/manager/trade/allocfund/transferorder/${orderId}/notify`,
    method: 'post',
    Headers: {
      'type': type
    }
  })
}

// 账户转账查询 - 批量转账订单
export function getTransferBatchOrder(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/transferorder/batch`,
    method: 'get',
    params
  })
}

// 账户转账查询 - 批量转账 - 同步
export function setTransferBatchSync(orderId, type) {
  return axios({
    url: `/manager/trade/allocfund/transferorder/batch/${orderId}/sync`,
    method: 'get',
    Headers: {
      'type': type
    }
  })
}

// 账户转账查询 - 批量转账 - 通知
export function setTransfeBatchNotify(orderId, type) {
  return axios({
    url: `/manager/trade/allocfund/transferorder/batch/${orderId}/notify`,
    method: 'post',
    Headers: {
      'type': type
    }
  })
}

// 账户转账查询 - 批量转账 - 详情
export function getTransferBatchOrdersDetail(orderId) {
  return axios({
    url: `/manager/trade/allocfund/transferorder/batch/${orderId}`,
    method: 'get'
  })
}

// 账户转账查询 - 批量转账 - 订单搜索 （mchBatchNo 批次转账订单号、plfBatchNo 批次转账流水号、upsBatchNo 三方批次转账订单号）
export function getTransferBatchOrderSearch(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/transferorder/batch/search`,
    method: 'get',
    params
  })
}

// 分账管理-分账代付-退款查询
export function getRefundsPay(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/pays`,
    method: 'get',
    params
  })
}
// 分账管理-分账代付-退款搜索
export function getRefundsPaySearch(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/pays/search`,
    method: 'get',
    params
  })
}
// 分账管理-分账代付-退款详情
export function getRefundsPayDetail(payId) {
  return axios({
    url: `/manager/trade/allocfund/pays/${payId}`,
    method: 'get'
  })
}
// 账户转账导出
export function exportRefundsPayOrder(params) {
  return axios({
    responseType: 'blob',
    url: `/manager/trade/allocfund/pays/export`,
    method: 'post',
    params
  })
}
// 分账代付-订单同步
export function getRefundsPaysync(payId, type) {
  return axios({
    url: `/manager/trade/allocfund/pays/${payId}/sync`,
    method: 'get',
    Headers: {
      'type': type
    }
  })
}
// 分账代付-订单通知
export function setRefundsPayNotify(payId, type) {
  return axios({
    url: `/manager/trade/allocfund/pays/${payId}/notify`,
    method: 'post',
    Headers: {
      'type': type
    }
  })
}
// 分账管理列表状态
export function setAccountsStatus(data) {
  return axios({
    url: `/manager/trade/allocfund/accounts/${data.thirdAccountId}/status`,
    method: 'put',
    data
  })
} 
export function setAccountsSpecialMch(data) {
  return axios({
    url: `/manager/trade/allocfund/accounts/${data.thirdAccountId}/specialMch`,
    method: 'put',
    data
  })
}

// 分账交易订单管理 同步
export function splitTradeSync(allorderId, type) {
  return axios({
    url: `/manager/trade/allocfund/orders/${allorderId}/sync`,
    method: 'get',
    Headers: {
      'type': type
    }
  })
}
// 分账交易订单管理 通知  
export function splitTradeNotify(allorderId, type) {
  return axios({
    url: `/manager/trade/allocfund/orders/${allorderId}/notify`,
    method: 'get',
    Headers: {
      'type': type
    }
  })
}

// 手工结算审核查询
export function getManualInquiry(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/settlechecks`,
    method: 'get',
		params
  })
}

//手工结算审核查询-结算订单搜索
export function getManualInquirySearch(params) {
  // params.loading = true
  return axios({
    url: `/manager/trade/allocfund/settlechecks/search`,
    method: 'get',
		params
  })
}

// 手工结算申请审核
export function  getManualsetCheck(data) {
  return axios({
    url: `/manager/trade/allocfund/check`,
    method: 'put',
		data
  })
}

// 手工结算 详情
export function getManualDetail(settleOrderId) {
  return axios({
    url: `/manager/trade/allocfund/settleorders/${settleOrderId}`,
    method: 'get'
  })
}